import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getFaqList = (params) => {
  return axiosClient.get("api/admin/faq", { params }).then((r) => r.data);
};
